import React from 'react';
import Styled from './Support.styled';
import Iara from 'images/homepage/support/iara.png';
import { ButtonHomeV2 } from '../button/ButtonHomeV2.styled';
import { GTM_Page_Home } from 'components/GoogleTagManager';
import { useHistory } from 'react-router-dom';

const Support = () => {
    const history = useHistory();

    const goToSuporte = () => {
        GTM_Page_Home('secao_suporte', 'btn_click_acessar_suporte');
        history.push('/suporte');
    };

    return (
        <Styled.Container>
            <Styled.ImageContainer>
                <Styled.Image src={Iara} alt="IAra" />
            </Styled.ImageContainer>

            <Styled.Content>
                <Styled.Title>Está com dificuldade e precisa de ajuda?</Styled.Title>

                <Styled.Description>
                    Fale com a Iara, a Inteligência Artificial para Rede de Aprendizagem do Instituto Ayrton Senna.
                </Styled.Description>

                <ButtonHomeV2 onClick={goToSuporte}>Fale com a IAra</ButtonHomeV2>
            </Styled.Content>
        </Styled.Container>
    );
};

export default Support;
